import React from "react";
import TextField from "@material-ui/core/TextField";
// import Grid from '@material-ui/core/Grid';
// import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
// import { Link} from "react-router-dom";
import Rating from "@material-ui/lab/Rating";
import AppBar from "../../header/index";
import SignInButton from "../../button/globleButtons";
import AppProvider from "../../bootstrap/index";
// import { TextInput} from 'react-admin';

// const labels = {
//     0.5: 'Useless',
//     1: 'Useless+',
//     1.5: 'Poor',
//     2: 'Poor+',
//     2.5: 'Ok',
//     3: 'Ok+',
//     3.5: 'Good',
//     4: 'Good+',
//     4.5: 'Excellent',
//     5: 'Excellent+',
//   };

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "55vh",
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField: {
    marginTop: "10%",
    backgroundColor: "#ffffff",
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    paddingBottom: "20px",
  },
}));
const FeedbackPage = (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(2);
  const [setHover] = React.useState(-1);
  const { handleSubmit } = props;
  return (
    <div className={classes.coverBackgroundContainer}>
      <AppProvider>
        <AppBar />
        <Container
          component="main"
          maxWidth="xs"
          style={{ background: "#ffffff", marginTop: "2%" }}
        >
          <div className={classes.paper}>
            <Typography
              component="h6"
              variant="h6"
              style={{ paddingTop: "4%" }}
            >
              Feedback
            </Typography>
            <div className={classes.root}>
              <Rating
                name="hover-feedback"
                value={value}
                precision={3}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                onChangeActive={(event, newHover) => {
                  setHover(newHover);
                }}
              />
            </div>

            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                multiline
                id="feedback"
                name="feedback"
                //  margin="normal"
                required
                placeholder="Enter Feedback"
                //  label="Email Address"
                type="multiline"
                //  autoComplete="email"
                variant="standard"
                fullWidth
              />
              {/* <Typography color="textSecondary"
                            className={
                                classes.subText1
                        }>
                            Lorem ipsum dolor sit amet, consectetur adipii scing   elit. sed cursus habitant tincidunt id
                            non feugiat.sed orci egestas cras porta arcu viverra eget.Fames sed blandit Sagittis malesuada enimest nisiamet massa. 
                                  
                        </Typography> */}

              <div style={{ marginTop: "6%" }}>
                <SignInButton buttonname="Submit" />
              </div>
            </form>
          </div>
        </Container>
      </AppProvider>
    </div>
  );
};
export default FeedbackPage;
